import { useEffect, useState } from 'react';
import { ChevronRightIcon } from '@radix-ui/react-icons';
import { Link, useNavigate, useParams } from 'react-router';
import { observer } from 'mobx-react-lite';

import { Header } from './project.page';
import { uiStore } from '../../core/stores/ui-store';
import { Storyboard } from '../../app/entities';
import { DropdownMenu, Item } from '../../components/modals/dropdown-menu/DropdownMenu';
import { RenameDialog } from '../../components/dialogs/rename.dialog';
import { StoryboardView } from '../../features/storyboards/components/storyboard-view';
import { LoaderContainer } from './components/step-container';
import { PageLoader } from '../../components/page-loader/PageLoader';
import { DeleteDialog } from '../../components/dialogs/DeleteDialog';
import { openModal } from '../../core/modal/open-modal';

import styles from './project-storyboard.route.module.scss';
export const ProjectStoryboardRoute = observer(() => {
  const { storyboardId } = useParams();
  const storyboard = Storyboard.getOne(storyboardId!);

  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    uiStore.currentLocation = 'project.storyboards';

    return () => {
      uiStore.currentLocation = '';
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1);
  }, []);

  const handleConfirmDelete = async () => {
    navigate('../');
    await storyboard?.delete();
  };

  const handleRename = (name: string) => {
    storyboard?.update({
      name,
    });
  };

  const handleDuplicate = async () => {
    const copy = await storyboard?.duplicate();

    if (copy) {
      navigate(`../${copy._id}`);
    }
  };

  const items: Item[] = [
    {
      title: 'Rename storyboard',
      onSelect: () =>
        openModal(RenameDialog, {
          defaultName: storyboard!.name,
          onSubmit: handleRename,
          title: 'Rename storyboard',
          label: 'File name',
        }),
    },
    {
      title: 'Duplicate storyboard',
      onSelect: handleDuplicate,
    },
    {
      title: 'Delete storyboard',
      type: 'danger' as const,
      onSelect: () =>
        openModal(DeleteDialog, {
          onSubmit: handleConfirmDelete,
          title: 'Delete storyboard',
          text: 'Are you sure you want to delete this storyboard?',
        }),
    },
  ];

  return (
    <>
      <Header>
        <div className={styles['crumb']}>
          <Link className={styles['parent']} to="../">
            Storyboards
          </Link>
          <ChevronRightIcon />
          {storyboard?.name}
        </div>

        <DropdownMenu items={items} />
      </Header>

      {isLoading || !storyboard ? (
        <LoaderContainer>
          <PageLoader />
        </LoaderContainer>
      ) : (
        <StoryboardView storyboard={storyboard} />
      )}
    </>
  );
});
